import React, { memo } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { openNewTab, reactHtmlParser } from '../../../common/common';
import LazyImage from '../../CustomLibraries/LazyImage';
import Card from '../components/Card';
const SampleCollectionCtaCard = ({
  className = '',
  type = '',
  onClick,
  image,
  title = '',
  subTitle = '',
  buttonText = '',
  description = '',
  clickCallback
}) => {
  const onClickCard = () => {
    clickCallback && clickCallback(ctaId);
    onClick && onClick();
  };
  const toShowImageFullSize = !title && !subTitle && !description;
  return (
    <Card
      className={`clr_v3_cornerGraphicsDynamic clr_v3_card--sampleCta ${className ?? ''}`}
      type={type}
    >
      <div className="position-absolute top-0 start-0 w-100 h-100 z-0 clr_v3_cornerGraphicsDynamic__Graphics z-0">
        {/* <img className='w-100 h-100 object-fit-cover' /> */}
        <div
          className="position-absolute rounded-circle graphics-size-md top right bg-soft-primary transition"
          style={{ opacity: '.4' }}
        ></div>
        <div
          className="position-absolute rounded-circle graphics-size-lg bordered border-5 border-soft-primary top right  transition"
          style={{ opacity: '.4' }}
        ></div>
      </div>
      <Card.Body>
        <div
          className={`d-flex ${type === 'small' ? 'flex-row align-items-center' : 'flex-column'}`}
          onClick={onClickCard}
        >
          {/* flex-row */}
          <div
            className={`${
              toShowImageFullSize ? '' : 'clr_v3_coverImage'
            } position-relative rounded-3 overflow-hidden flex-shrink-0 cursorPointer`}
          >
            <LazyImage
              src={image}
              alt="banner"
              fallback_image={
                'https://previews.123rf.com/images/varijanta/varijanta1604/varijanta160400086/55848266-modern-thin-line-design-concept-for-healthcare-website-banner-vector-illustration-concept-for-health.jpg'
              }
              className="mw-100 mh-100 w-auto h-auto"
              extraClass={`position-relative ${
                toShowImageFullSize ? '' : 'p-sm-20 p-4'
              } d-flex align-items-center justify-content-center w-100 h-100`}
            />
          </div>

          <div className="d-flex flex-column">
            {title && <Card.Title className="hover-opacity">{title}</Card.Title>}
            {subTitle && (
              <h2
                className={
                  'fs-5 text-black line-clamp-2 fw-semibold mt-3 text-decoration-underline'
                }
              >
                {subTitle}
              </h2>
            )}
            {description && (
              <Card.Description showFullText>{reactHtmlParser(description)}</Card.Description>
            )}

            <div className="mt-4 d-flex gap-3 flex-wrap ">
              {/* <Button
                variant="primary"
                className={`fw-semibold rounded-3 py-3 flex-grow-1 border-105`}
                onClick={onClick}
              >
                {buttonText}
              </Button> */}

              <Button
                size="sm"
                className={`flex-grow-1 text-nowrap fs-4 gap-2 d-flex justify-content-center align-items-center`}
                onClick={onClickCard}
              >
                {buttonText}
                <i className="flaticon-next"></i>
              </Button>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default memo(SampleCollectionCtaCard);
